/**
 * Authentication TypeScript Types
 * Comprehensive interface definitions for the authentication system
 */
export interface AuthUser {
  sub: string;
  email: string;
  name?: string;
  nickname?: string;
  picture?: string;
  given_name?: string;
  family_name?: string;
  locale?: string;
  updated_at?: string;
  email_verified?: boolean;
}

export type AuthenticationState = 'loading' | 'authenticated' | 'unauthenticated' | 'error' | 'pending_authentication' | 'unauthorized' | 'pending_authorization';

export interface AuthContextValue {
  // Auth0 user and authentication state
  isAuthenticated: boolean;
  isLoading: boolean;
  user: AuthUser | null; // Updated to match actual type
  token?: string | null;
  
  // Custom user profile from backend
  
  // Authentication methods
  loginWithRedirect?: () => void;
  logout?: (options?: any) => void;
  
  // Additional auth state
  unauthorizedUser: boolean;

  // Actions
  signOut: () => Promise<void>;
  getUserProfileIdHeader: () => { userProfileExternalObjectId: string } | null;
}

export interface PracticeOption {
  id: number;
  name: string;
  externalObjectId: string;
  externalUserName: string;
  city?: string;
  state?: string;
}

export interface UserProfileResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export interface ClearCacheResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export interface Auth0Config {
  domain: string;
  clientId: string;
  audience?: string;
  scope?: string;
  redirectUri?: string;
  returnTo?: string;
}

// Session storage keys
export const AUTH_STORAGE_KEYS = {
  USER_PROFILE: 'auth_user_profile',
  PROFILE_TIMESTAMP: 'auth_profile_timestamp',
  SESSION_ID: 'auth_session_id',
  LAST_ACTIVITY: 'auth_last_activity',
  USER_PROFILE_ID: 'auth_user_profile_id'
} as const;

// Auth states for UI components
export type AuthState = 'loading' | 'authenticated' | 'unauthenticated' | 'error' | 'unauthorized';

export interface AuthError {
  code: string;
  message: string;
  description?: string;
  error?: string;
  error_description?: string;
}

export interface IdleTimerConfig {
  timeout: number; // Total session timeout in milliseconds
  warningTime: number; // Warning time before timeout
  crossTab: boolean; // Enable cross-tab synchronization
}